module.exports = "<p>\n    refresh works!\n</p>\n"